import { createContext } from "react";

const CentroMezclasContext = createContext();

export default CentroMezclasContext;
